<ion-searchbar placeholder="Search inventory" [(ngModel)]="searchTerm" [debounce]="500" *ngIf="showSearchbar"></ion-searchbar>

<ion-card class="ion-padding" *ngIf="show">
  <bones-card-toolbar [title]="title" [note]="showingText()" [actions]="cardMenu" [expandable]="true" [(expanded)]="showInventory">
  </bones-card-toolbar>

  <ion-card-content  class="ion-no-padding" *ngIf="showInventory">
    <ion-item-group *ngFor="let group of groups">
      <ion-item-divider>
        <ion-label>{{ group.by }}</ion-label>
      </ion-item-divider>
      <inventory-list [inventory]="group.items" [showBreweryName]="showBreweryName" [showBeerName]="showBeerName"></inventory-list>
    </ion-item-group>

    <div class="ion-text-right">
      <ion-button (click)="showMore()" *ngIf="truncated">More</ion-button>
    </div>

  </ion-card-content>
</ion-card>
